import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  get: (path) => axios.get(`${API}${path}`).then((r) => r.data),
  post: (path, data) => axios.post(`${API}${path}`, data).then((r) => r.data),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "That did not go through. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => (item && typeof item.msg === "string" ? item.msg : "Please check the form and try again."))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "That did not go through. Please try again.";
}
